export enum AkixiEntities {
    TEL_SYS = 'telsys',
    PARTITION = 'partition',
    GROUPS = 'group',
    DEVICE = 'device',
    DEVICES = 'devices',
    DIRECTORY = 'directoryEntry',
    CODES = 'code',
    ACD_AGENTS = 'acdagent',
    CALL = 'call',
    RECORDING = 'recording',
    CME = 'cme',
    USER = 'user',
    CALL_CTRL_PROPS = 'callCtrlProps',
    GROUP_MEMBERS = 'groupmembers',
    /** Path segment for users linked to a device or ACD agent (internal API). */
    LINKED_USERS = 'linkedusers',
    PASSWORD = 'password',
    LANGUAGE = 'language',
    ACDDND = 'acdactivity',
    CONTACT = 'contact',
    CALL_DETAILS = 'callDetails',
    DEFAULT_REPORTS = 'defaultReportCollection',
    USER_ROLE = 'role'
}
